import { Button, buttonVariants } from '@askable/ui/core/button';
import { Box, ClipboardError, MessageCircle, Review, Warning } from '@askable/ui/illustrations';
import { cn } from '@askable/ui/lib/utils';

import { EmptyState } from 'components/EmptyState/EmptyState';
import { Link } from 'src/lib/routing';

import type { ReactNode } from 'react';

export type ErrorStateAction = { label: string; to: string } | { label: string; onClick: () => void };

const ILLUSTRATIONS = {
  notFound: ClipboardError,
  project: Box,
  error: Warning,
  chat: MessageCircle,
  noAccess: Review,
} as const;

type ErrorStateVariant = keyof typeof ILLUSTRATIONS;

export type ErrorStateProps = {
  variant: ErrorStateVariant;
  title: string;
  description?: ReactNode;
  action?: ErrorStateAction;
  className?: string;
};

const ActionButton = ({ action }: { action: ErrorStateAction }) => {
  if ('to' in action) {
    return (
      <Link to={action.to} className={buttonVariants({ variant: 'primary' })}>
        {action.label}
      </Link>
    );
  }

  return (
    <Button variant="primary" onClick={action.onClick}>
      {action.label}
    </Button>
  );
};

export const ErrorState = ({ variant, title, description, action, className }: ErrorStateProps) => {
  const Illustration = ILLUSTRATIONS[variant];
  const stringDescription = typeof description === 'string' ? description : undefined;
  const nodeDescription = description && typeof description !== 'string' ? description : null;

  return (
    <div className={cn('flex h-full w-full flex-1 items-center justify-center', className)}>
      <EmptyState icon={<Illustration />} title={title} description={stringDescription}>
        {nodeDescription ? <p className="text-pretty">{nodeDescription}</p> : null}
        {action ? <ActionButton action={action} /> : null}
      </EmptyState>
    </div>
  );
};
